// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { isDurationStep, utils } from '@seedplanner/shared-utils';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Box, Card } from '../../lib/base';
import type { SingleCropQuery } from '../../types/__generated__/graphql';
import { formatNotes } from '../../utils';
import { PageLoading } from '../common/loading';
import TableView from '../common/view/TableView';
import { sortCropSteps } from './utils';

type CropStep = NonNullable<SingleCropQuery['crop']>['steps']['edges'][number]['node'];
interface Props {
  readonly sortedSteps: (CropStep & { duration: number })[];
  readonly loading: boolean;
}

function formatStepDays(timeToStart: number) {
  const days = Math.floor(timeToStart / (3600 * 24));
  return `Day ${days}`;
}

export default function CropStepsView({ sortedSteps, loading }: Props) {
  // TODO: move loading indicator to table view
  if (loading) {
    return <PageLoading />;
  }

  const stepsTables = sortedSteps.sort(sortCropSteps).map((step, idx) => {
    const whenToStart = formatStepDays(step.time_to_start_after_first_step);
    const notes = formatNotes(step.description, '-');
    let columns: Array<[string, React.ReactElement | string] | [string, React.ReactElement | string, number]> = [
      ['Step Name', step.name],
      ['When To Start', whenToStart],
      ['Description', notes],
    ];
    if (isDurationStep(step.name)) {
      columns = [
        ['Step Name', step.name],
        ['When To Start', whenToStart],
        ['Duration', `${utils.round(step.duration / 24 / 60 / 60, 1)} days`],
        ['Description', notes],
      ];
    }
    return (
      <Card key={step.id} sx={{ mt: idx === 0 ? 0 : 1 }}>
        <TableView columns={columns} />
      </Card>
    );
  });

  return <Box sx={{ mt: 2 }}>{stepsTables}</Box>;
}
